import aesjs from "aes-js";
import * as systemUtils from "./systemUtils";

export const urlCode = [ 90, 12, 223, 226, 10, 67, 84, 105, 141, 144, 74, 113, 36, 2, 161, 170 ];
export const urlRegion = [ 70, 158, 204, 102, 222, 110, 64, 238, 237, 164, 24, 64, 92, 54, 118, 135 ];
export const urlEndpoint = [ 121, 20, 213, 234, 14, 67, 69, 11, 121, 59, 17, 229, 105, 171, 18, 193 ];

const padTo16 = (input) => {
  return input.padEnd(16, " ");
};

export const getKeyFromString = (password) => {
  const parsed = padTo16(password.trim());

  return new aesjs.AES(aesjs.utils.utf8.toBytes(parsed));
};

export const encrypt = (aes, plain) => {
  const padded = padTo16(plain.trim());

  return aes.encrypt(aesjs.utils.utf8.toBytes(padded));
};

export const decrypt = (aes, cipher) => {
  return aesjs.utils.utf8.fromBytes(aes.decrypt(cipher)).trim();
};

export const getUrlGenerator = (password) => {
  const key = getKeyFromString(password);

  const code = decrypt(key, urlCode);
  const region = decrypt(key, urlRegion);
  const endpoint = decrypt(key, urlEndpoint);

  const url = `https://${code}.execute-api.${region}.amazonaws.com/${endpoint}`;

  console.log("AES", url);

  systemUtils.saveToSessionStorage("api", url);

  return url;
};

export const init = () => {
  const api = systemUtils.loadFromLocalStorage("api");
  
  if (!api) {
    systemUtils.saveToLocalStorage("api", 'https://ejz4dvakvgmx3vrxpjl4uwh4uu0uhfka.lambda-url.us-east-1.on.aws/tomato');
  }

  // if (api) {
  //   return;
  // } else {
  //   const password = prompt("To unlock all features, provide the password!");
  //   getUrlGenerator(password);
  // }
};